<!-- Facebook Feed (desktop) -->
<div class="fbp fbp-desktop">
  <div class="fbp-header">
    <img class="fbp-avatar" [src]="avatar" alt="" />
    <div class="fbp-identity">
      <div class="fbp-name">{{ pageName }}<i class="bi bi-patch-check-fill fbp-verified"></i></div>
      <div class="fbp-meta">Plaćeni oglas · <i class="bi bi-globe-americas"></i></div>
    </div>
    <div class="fbp-header-icons">
      <i class="bi bi-three-dots"></i>
      <i class="bi bi-x-lg"></i>
    </div>
  </div>

  <div class="fbp-text">
    <div class="fbp-paragraph" *ngFor="let paragraph of paragraphs">{{ paragraph }}</div>
  </div>

  <a class="fbp-link" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <app-meta-creative [src]="data.creative" [kind]="data.creativeKind" slot="feed"></app-meta-creative>
    <div class="fbp-cta-bar">
      <div class="fbp-cta-copy">
        <div class="fbp-domain">{{ domain }}</div>
        <div class="fbp-headline">{{ headline }}</div>
      </div>
      <span class="fbp-cta">{{ cta }}</span>
    </div>
  </a>
</div>
